/*
Copyright (c) 2020 by Stevie. All Rights Reserved.
*/
import Home from '../Pages/Home'
import Calendar from '../Pages/Calendar'
import LandingPage, { ProductPage } from '../Pages/Defaults'
import Details from '../Pages/Records'
import Preview from '../Pages/Records/Preview'
import Visit from '../Pages/Records/Visit'
import Contact from '../Pages/Records/Contacts'
import EventAudit from '../Pages/Audit'
import Events from '../Pages/Calendar/Main'
import device_ico from '../../assets/menu/device.svg'
import tools_ico from '../../assets/menu/tools.png'
import system_ico from '../../assets/menu/system.png'

import { MenuRoute } from './d';

export default [
  {
    pathname: 'eventCalendar',
    displayName: 'eventCalendar',
    icon: device_ico,
    content: Calendar
  },
  {
    pathname: '',
    displayName: 'records',
    icon: device_ico,
    content: Home
  },
  {
    pathname: 'details',
    displayName: '',
    icon: system_ico,
    content: Details
  },
  {
    pathname: 'details/:share?',
    displayName: '',
    icon: system_ico,
    content: Preview
  },
  {
    pathname: 'visit',
    displayName: '',
    icon: system_ico,
    content: Visit
  },
  {
    pathname: 'contact',
    displayName: '',
    icon: system_ico,
    content: Contact
  },
  {
    pathname: 'login',
    displayName: '',
    icon: system_ico,
    content: LandingPage
  },
  {
    pathname: 'product',
    displayName: '',
    icon: system_ico,
    content: ProductPage
  },
  {
    pathname: 'audit',
    displayName: '',
    icon: system_ico,
    content: EventAudit
  },
  {
    pathname: 'events',
    displayName: '',
    icon: system_ico,
    content: Events
  },
] as MenuRoute;


export const header = [

] as MenuRoute;
